<template>
    <div class="HomeHionDev">
        <PageTitle icon="fas fa-user-lock iconInterativoTitulo" main="PLATAFORMA TÉCNICA HION"
            sub="Dashboard Interativo" />

        <hr class="ml-2 mr-2">
        
    </div>
</template>

<script>
//import VueScrollTo from 'vue-scrollto'
import PageTitle from '../PageTitle'
//import { baseApiUrl, userKey, showError } from '../../../global'
//import axios from 'axios'

export default {
    name: 'HomeHionDev',
    components: { PageTitle } ,
    data: function() {
        return {
           
        }
    },
    computed: {
        
    },
    methods: {
        
    },
    mounted() {
        
    }
}
</script>

<style>
    .HomeHionDev {
        position: relative;
        width: 100%;
        height: 100%;
    }
</style>